<template>
	<modal class="modal" ref="modalSenha">
		<button
			type="button"
			class="close"
			@click="$refs.modalSenha.modalHide(), $emit('fecha-modal')"
		>
			<span aria-hidden="true">&times;</span>
		</button>
		<h4 v-if="controleSenha" class="modal-title">ALTERAR SENHA</h4>

		<h4 v-if="!controleSenha" class="modal-title">ALTERAR ASSINATURA</h4>

		<hr style="margin-top: 6px" />

		<div>
			<div class="row" v-if="usuarioAdministrador">
				<div class="col-xs-4">
					<label for=""
						>* Redefinir a senha do usuário no próximo acesso?</label
					>
					<flSimNao
						v-model="redefinirSenhaAdministrador"
						:value="redefinirSenhaAdministrador"
					/>
				</div>
			</div>
			<div
				class="row"
				:style="{
					'display': !_isMobile ? 'flex' : '',
					'align-items': !_isMobile ? 'center' : ''
				}"
			>
				<div
					class="col-xs-12 col-md-4 text-center"
					:style="{'justify-items': !_isMobile ? 'stretch' : ''}"
				>
					<i
						class="fa fa-fw fa-lock text-primary"
						style="
							font-size: 130px;
							padding: 20px;
							border: 1px solid;
							border-radius: 50%;
							color: ;
						"
					></i>
				</div>

				<div class="col-xs-12 col-md-8" v-if="!redefinirSenhaAdministrador">
					<div class="row">
						<div class="col-xs-12 form-group">
							<label v-if="controleSenha"
								>* {{ _traducao('login', 'digiteSenhaAtual') }}:
								<strong style="color: red"
									>{{ _traducao('global', 'senhaUtilizadaAoLogar') }}.</strong
								></label
							>
							<label v-else
								>* {{ _traducao('login', 'digiteSenhaAtual') }}:
								<strong style="color: red"
									>{{ _traducao('global', 'senhaUtilizadaAoLogar') }}.</strong
								></label
							>
							<input
								autocomplete="off"
								v-show="inputSenhaAtual"
								type="password"
								class="input-sm form-control"
								v-model="form.senha_atual"
							/>
							<input
								autocomplete="off"
								v-show="!inputSenhaAtual"
								type="password"
								class="input-sm form-control"
								v-focus="form.senha_atual"
								v-model="form.senha_atual"
							/>
						</div>

						<div v-if="controleSenha" class="col-xs-12 form-group">
							<label>* {{ _traducao('global', 'novaSenha') }}:</label>
							<input
								autocomplete="off"
								v-show="inputSenha"
								type="password"
								class="input-sm form-control"
								v-model="form.senha"
							/>
							<input
								autocomplete="off"
								v-show="!inputSenha"
								type="password"
								class="input-sm form-control"
								v-model="form.senha"
							/>
						</div>

						<div v-else class="col-xs-12 form-group">
							<label>* {{ _traducao('global', 'novaAssinatura') }}:</label>
							<input
								autocomplete="off"
								v-show="inputAssinatura"
								type="password"
								class="input-sm form-control"
								v-model="form.assinatura"
								@keydown="checkChar"
								maxlength="8"
							/>
							<input
								autocomplete="off"
								v-show="!inputAssinatura"
								type="password"
								class="input-sm form-control"
								v-model="form.assinatura"
								@keydown="checkChar"
								maxlength="8"
							/>
						</div>

						<div v-if="controleSenha" class="col-xs-12 form-group">
							<label>* Confirmar Nova Senha:</label>
							<input
								autocomplete="off"
								v-show="inputNovaSenha"
								type="password"
								class="input-sm form-control"
								v-model="confirmaSenhaAss"
								@keyup="validaConfirmacao()"
							/>
							<input
								autocomplete="off"
								v-show="!inputNovaSenha"
								type="password"
								class="input-sm form-control"
								v-model="confirmaSenhaAss"
								@keyup="validaConfirmacao()"
							/>
							<span v-if="msgConfirmacao" class="text-danger"
								>* {{ _traducao('global', 'senhasNaoCoincidem') }}.</span
							>
						</div>

						<div v-else class="col-xs-12 form-group">
							<label>
								* {{ _traducao('global', 'confirmarAssinatura') }}:</label
							>
							<input
								autocomplete="off"
								v-show="inputNovaSenha"
								type="password"
								class="input-sm form-control"
								v-model="confirmaSenhaAss"
								@keydown="checkChar"
								@keyup="validaConfirmacao()"
							/>
							<input
								autocomplete="off"
								v-show="!inputNovaSenha"
								type="password"
								class="input-sm form-control"
								v-model="confirmaSenhaAss"
								@keydown="checkChar"
								@keyup="validaConfirmacao()"
							/>
							<span v-if="msgConfirmacao" class="text-danger"
								>* {{ _traducao('global', 'senhasNaoCoincidem') }}.</span
							>
						</div>
					</div>
				</div>
				<div class="col-xs-12 col-md-8" v-else>
					<div class="row">
						<div class="col-xs-12">
							<label
								>* Digite a sua senha (administrador):
								<strong style="color: red"
									>{{ _traducao('global', 'senhaUtilizadaAoLogar') }}.</strong
								></label
							>
							<input
								autocomplete="off"
								type="password"
								class="input-sm form-control"
								v-model="form.senhaAdministrador"
							/>
							<p><AlertInfo>A senha do usuário será igual ao login, e o sistema solicitará que ele a altere no próximo acesso.</AlertInfo></p>
						</div>
					</div>
				</div>
			</div>
			<hr />
			<div class="row">
				<div class="col-xs-12 col-md-12">
					<button
						class="btn btn-success pull-right"
						:disabled="desabilitaSalvar"
						@click="salvar()"
						v-if="!redefinirSenhaAdministrador"
					>
						<i class="fa fa-check"></i>
						SALVAR
					</button>
					<button
						class="btn btn-success pull-right"
						@click="resetarSenhaUsuario()"
						v-else
					>
						SALVAR
					</button>
				</div>
			</div>
		</div>
	</modal>
</template>
<script>
export default {
	props: {
		token: {
			type: String,
			require: false
		}
	},

	data() {
		return {
			inputSenhaAtual: false,
			inputSenha: false,
			inputAssinatura: false,
			inputNovaSenha: false,
			redefinirSenhaAdministrador: false,
			usuarioAdministrador: false,
			form: {
				id: 0,
				tipo: '',
				assinatura: '',
				senha_atual: '',
				senha: '',
				senhaAdministrador: ''
			},

			confirmaSenhaAss: '',

			msgConfirmacao: false,

			controleSenha: true //verifica se é uma alteração de senha ou assinatura
		}
	},

	computed: {
		desabilitaSalvar() {
			if (
				this.form.senha_atual != '' &&
				(this.form.senha != '' || this.form.assinatura != '') &&
				this.confirmaSenhaAss != '' &&
				this.msgConfirmacao != true
			) {
				return false
			} else {
				return true
			}
		}
	},

	async mounted() {
		this.usuarioAdministrador = await this.asyncVerificaPerfilAdministrador()
	},

	methods: {
		carregaModal(controlaSenha, id) {
			this.controleSenha = controlaSenha
			this.form.id = id

			if (this.controleSenha) {
				this.form.tipo = 'S'
			} else {
				this.form.tipo = 'A'
			}

			this.$refs.modalSenha.modalShow(40)
		},

		validaConfirmacao() {
			if (this.controleSenha) {
				if (this.confirmaSenhaAss != this.form.senha) {
					this.msgConfirmacao = true
				} else {
					this.msgConfirmacao = false
				}
			} else {
				if (this.confirmaSenhaAss != this.form.assinatura) {
					this.msgConfirmacao = true
				} else {
					this.msgConfirmacao = false
				}
			}
		},

		salvar() {
			let data = {
				id: this.form.id,
				tipo: this.form.tipo,
				senha_atual: this.form.senha_atual
			}

			if (data.tipo == 'A') {
				data.assinatura = this.form.assinatura
				bus.$emit('load-in', {text: 'Atualizando Assinatura'})
			} else {
				data.senha = this.form.senha
				bus.$emit('load-in', {text: 'Atualizando Senha'})
			}

			this._httpPost(
				'Usuario/nova_senha',
				data,
				(response) => {
					bus.$emit('load-out')
					if (response._request && response._status) {
						bus.$emit('exibir-notificacao', {
							text: `${
								data.tipo == 'S'
									? 'Senha Alterada com sucesso'
									: 'Assinatura Alterada com sucesso'
							}`,
							type: 'success'
						})

						this.$refs.modalSenha.modalHide()

						this.$emit('fecha-modal')
					} else {
						bus.$emit('exibir-notificacao', {
							text: `Não foi possível salvar ${response.mensagem}`,
							type: 'danger'
						})
					}
				},
				this.token
			)
		},
		clickSenhaAtual(item) {
			if (item) {
				this.inputSenhaAtual = true
			} else {
				this.inputSenhaAtual = false
			}
		},

		clickSenha(item) {
			if (item) {
				this.inputSenha = true
			} else {
				this.inputSenha = false
			}
		},

		clickSenhaAssinatura(item) {
			if (item) {
				this.inputAssinatura = true
			} else {
				this.inputAssinatura = false
			}
		},
		clickNovaSenha(item) {
			if (item) {
				this.inputNovaSenha = true
			} else {
				this.inputNovaSenha = false
			}
		},

		checkChar(char) {
			var pattern = '[0-9]|Backspace|Delete'
			if (char.key.match(pattern)) {
				return true
			} else {
				return char.preventDefault()
			}
		},

		asyncVerificaPerfilAdministrador() {
			return new Promise((resolve) => {
				this._httpGet(
					'Perfil/verifica_perfil_administrador/' + this._idUsuario,
					(response) => {
						if (response._request && response._status) {
							if (response.lista) {
								resolve(response.lista)
							}
						}
					}
				)
			})
		},

		resetarSenhaUsuario() {
			let infoPost = {
				id_usuario_administrador: $sessao.getId(),
				id_usuario: this.form.id,
				senha: this.form.senhaAdministrador
			}
			window.bus.$emit('load-in', {text: this._traducao('global', 'salvando')})
			this._axios('/Usuario/reseta_senha_usuario', 'post', {
				data: infoPost,
				callback: (response) => {
					if (response.lista != []) {
						bus.$emit('exibir-notificacao', {
							type: 'success',
							text: this._traducao('global', 'salvoComSucesso')
						})
						this.$refs.modalSenha.modalHide()
					} else {
						bus.$emit('exibir-notificacao', {
							type: 'danger',
							text: 'Senha incorreta.'
						})
					}
				},
				finally: () => {
					window.bus.$emit('load-out')
				}
			})
		}
	}
}
</script>